import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/pages/login/login.component';
import { RecoverPasswordComponent } from './features/auth/pages/recover-password/recover-password.component';
import { HomePageComponent } from './features/quotas/pages/home-page/home-page.component';
import { MyApplicationsComponent } from './features/quotas/pages/my-applications/my-applications.component';
import { MyCompaniesComponent } from './features/quotas/pages/my-companies/my-companies.component';
import { AdminDashboardComponent } from './features/admin/pages/admin-dashboard/admin-dashboard';
import { Dashboard } from './features/admin/pages/dashboard/dashboard';
import { ApplicationsRegisterComponent } from './features/admin/pages/applications-register/applications-register.component';
import { SupplierRegistrationComponent } from './features/quotas/pages/supplier-registration/supplier-registration';
import { UserExternalComponent } from './features/auth/pages/user-external/user-external.component';
import { EkyzmatCallback } from './features/auth/pages/ekyzmat-callback/ekyzmat-callback';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { supplierGuard } from './core/guards/supplier.guard';
import { supplierRegistrationGuard, canLeaveRegistrationGuard } from './core/guards/supplier-registration.guard';
import { needsRoleGuard } from './core/guards/needs-role.guard';
import { AssignRoleComponent } from './features/auth/pages/assign-role/assign-role.component';
import { QuotasAdminComponent } from './features/admin/pages/quotas-admin/quotas-admin';
import { DestributionQuotas } from './features/admin/pages/destribution-quotas/destribution-quotas';
import { CurrentSuppliers } from './features/admin/pages/current-suppliers/current-suppliers';
import { PastSuppliers } from './features/admin/pages/past-suppliers/past-suppliers';

export const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
    canActivate: [needsRoleGuard, supplierRegistrationGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'assign-role',
    component: AssignRoleComponent,
    canActivate: [authGuard]
  },
  {
    path: 'recoverpassword',
    component: RecoverPasswordComponent
  },
  {
    path: 'admin',
    component: AdminDashboardComponent,
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: Dashboard
      },
      {
        path: 'applications/register',
        component: ApplicationsRegisterComponent
      },
      {
        path: 'quotas',
        component: QuotasAdminComponent
      },
      {
        path: 'destribution-quotas',
        component: DestributionQuotas
      },
      {
        path: 'current-suppliers',
        component: CurrentSuppliers
      },
      {
        path: 'past-suppliers',
        component: PastSuppliers
      }
    ]
  },
  {
    path: 'supplier-registration',
    component: SupplierRegistrationComponent,
    canActivate: [needsRoleGuard, supplierGuard],
    canDeactivate: [canLeaveRegistrationGuard]
  },
  {
    path: 'my-applications',
    component: MyApplicationsComponent,
    canActivate: [authGuard, needsRoleGuard, supplierRegistrationGuard]
  },
  {
    path: 'my-companies',
    component: MyCompaniesComponent,
    canActivate: [authGuard, needsRoleGuard, supplierRegistrationGuard]
  },
  {
    path: 'user/external',
    component: UserExternalComponent,
    canActivate: [authGuard, needsRoleGuard]
  },
  {
    path: 'e-id/callback',
    component: EkyzmatCallback
  },
  {
    path: '**',
    redirectTo: ''
  }
];
